import { createFileRoute } from "@tanstack/react-router";
import ContactPage from "@/pages/ContactPage";
import { pageHead, SITE_URL } from "@/lib/seo";

const title = "Contacter CMO Partner | Fractional CMO à Bordeaux";
const description =
  "Un projet marketing, CRM ou IA ? Décrivez votre besoin en 2 minutes ou réservez directement un appel de 30 minutes. Réponse sous 24 h ouvrées.";

export const Route = createFileRoute("/contact")({
  head: () => {
    const h = pageHead({
      path: "/contact",
      title,
      description,
      enPath: null,
      crumbs: [["Contact", "/contact"]],
      schemas: [
        {
          "@context": "https://schema.org",
          "@type": "ContactPage",
          name: title,
          description,
          url: `${SITE_URL}/contact`,
          about: { "@type": "Organization", name: "CMO Partner", url: SITE_URL, email: "contact@cmopartner.fr" },
        },
      ],
    });
    return { ...h, meta: [...h.meta, { property: "og:type", content: "website" }, { name: "twitter:card", content: "summary" }] };
  },
  component: ContactPage,
});
